import { awsSecurityHubPlugin } from './plugin';

export default awsSecurityHubPlugin;